"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.steam = steam;
const uom_1 = require("uom");
const uom_2 = require("@genesys/uom");
const value_1 = require("./value");
function steam() {
    return [
        (0, value_1.createAmount)("temperature", uom_1.Amount.create(28, uom_2.Units.Celsius), uom_2.Units.Celsius, uom_2.Units.Fahrenheit),
        (0, value_1.createAmount)("humidity", uom_1.Amount.create(0, uom_2.Units.GramPerKilogram), uom_2.Units.GramPerKilogram, uom_2.Units.GrainPerPoundLb),
        (0, value_1.createAmount)("pressure", uom_1.Amount.create(101325, uom_2.Units.Pascal), uom_2.Units.Pascal, uom_2.Units.PoundForcePerSquareInch),
        (0, value_1.createAmount)("steam_pressure", uom_1.Amount.create(5, uom_2.Units.Bar), uom_2.Units.Bar, uom_2.Units.Bar),
        (0, value_1.createAmount)("sub cooling", uom_1.Amount.create(0, uom_2.Units.DeltaCelsius), uom_2.Units.DeltaCelsius, uom_2.Units.DeltaFahrenheit),
        (0, value_1.createAmount)("super heat", uom_1.Amount.create(0, uom_2.Units.DeltaCelsius), uom_2.Units.DeltaCelsius, uom_2.Units.DeltaFahrenheit)
    ];
}
//# sourceMappingURL=steam.js.map